export default "__VITE_ASSET__CVd4qY_L__"